import { render, staticRenderFns } from "./tennis-find-a-hit-matcha.vue?vue&type=template&id=c8d2e51a"
import script from "./tennis-find-a-hit-matcha.vue?vue&type=script&lang=ts"
export * from "./tennis-find-a-hit-matcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports